<template>
  <div
    class="review"
    style="
      background-color: rgba(234,239,243,1);
      margin-left: 0;
      margin-right: 0;
      width: 100%;
    "
    id="parttwo"
    ref="partii"
  >
    <div class="big-title"><h3>智慧产品功能简介</h3></div>
    <div
      class="back"
      style="width: 100%;"
    >
      <div class="title" style="display: flex; flex-direction: row">
        <div class="leftMenu">
          <div
            v-for="(item, index) in arr4"
            :key="index"
            @mouseenter="mouseOver4(index)"
            @mouseleave="mouseLeave4(index)"
          >
            <div
              class="leftMenu-item"
              :class="{ hoverItem: nowindex4 === index }"
            >
              {{ item.content }}
            </div>
          </div>
        </div>
        <div class="rightContent">
          <div class="right-title">
            {{ arr5[nowindex4].title }}
          </div>
          <div class="right-content">
            {{ arr5[nowindex4].content }}
          </div>
          <img style="width:100%;margin-top:30px;border:20px solid rgb(204, 220, 236);border-radius:20px;" :src="arr5[nowindex4].url" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'sidemenu',
  data () {
    return {
      nowindex4: 0,
      nowIndex: [0]
    }
  },
  props: {
    arr4: {
      type: Array,
      default: () => []
    },
    arr5: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    mouseOver: function (x) {
      this.nowindex = x
    },
    mouseLeave: function (x) {
      this.nowindex = -1
    },
    mouseOver2: function (x) {
      this.nowindex2 = x
    },
    mouseLeave2: function (x) {
      this.nowindex2 = -1
    },
    mouseOver3: function (x) {
      this.nowindex3 = x
    },
    mouseLeave3: function (x) {
      this.nowindex3 = -1
    },
    mouseOver4: function (x) {
      this.nowindex4 = x
    },
    mouseLeave4: function (x) {
      this.nowindex4 = x
    },

    mouseOvers: function (type, index) {
      this.nowIndex[type] = index
    },
    mouseLeaves: function (type, index) {
      this.nowIndex[type] = 0
    }
  }
}
</script>
<style scoped>
.title {
  width: 1200px;
  text-align: center;
  margin: 0 auto;
}
.big-title {
  margin: auto;
  padding-top:5%;
}
.right-title {
  padding-bottom: 20px;
  text-align: left;
  font-size: 24px;
  position: relative;
}
.right-title:after {
  content: "";
  position: absolute;
  bottom: 10px;
  left:0%;
  width: 45px;
  border-bottom: 7px solid rgb(26, 87, 218);
}
.right-content {
  text-align: left;
  padding-top: 30px;
  line-height: 40px;
}

.leftMenu {
  display: flex;
  flex-direction: column;
  width: 150px;
  text-align: left;
  padding: 10% 0%;
  box-shadow: -20px 0px 20px -10px rgb(0 0 0 / 4%) inset;
}

.leftMenu-item {
  padding:18% 10% 18% 10%;
  position: relative;
}

.rightContent {
  width: 100%;
  padding:10%;
}

.hoverItem {
  background-color: rgba(45,139,238,1);
  color: ivory;
  width:140%;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/sidemenu.vue